// B2C means service category is service for families
// B2B means service category is medical staffing
export const TOTAL_B2C_ASSESSMENT_STEPS = 9;
export const TOTAL_B2B_ASSESSMENT_STEPS = 8;

// There are five possible headings and form combinations per step
// in the worst-case. Assign a blank heading or empty array to cases
// that will not be possible for easier type handling.

//   The possible combinations are:
//     1. Medical staffing
//     2. Services for families no type
//     3. Services for families with medical needs (steps 5 and 6)
//     4. Services for families with non-medical needs (steps 5 and 6)
//     5. Services for families with both needs
export const STEPS_BRANCHED_BY_CATEGORY_AND_TYPE = [5, 6];
// The step where b2c type will be asked
// B2C (service for families) type can be either medical, non-medical, or both
export const STEP_B2C_TYPE = 4;

export const HEADINGS = {
  1: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default:
        "To ensure you get our personalized care proposal, please provide your contact information.",
    },
    "medical-staffing":
      "To ensure you get our tailored staffing proposal, please provide your contact information.",
  },
  2: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default: "Who needs care?",
    },
    "medical-staffing": "What is your role and organization?",
  },
  3: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default:
        "Where does the person needing care currently live? Please choose the option that best describes their living situation:",
    },
    "medical-staffing":
      "What type of medical setting are you looking to staff?",
  },
  4: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default:
        "What type of care does the person needing assistance require? Please select all that apply:",
    },
    "medical-staffing": "Which staffing solution do you require?",
  },
  5: {
    "services-for-families": {
      medical:
        "Which of these care services are necessary for this medical care? Please select all that apply.",
      "non-medical":
        "Which of these activities are required for this care? Please select all the apply:",
      both: "Which of these activities are required for this care? Please select all the apply:",
      default: "",
    },
    "medical-staffing":
      "What type of staff are you looking for? Select all that apply.",
  },
  6: {
    "services-for-families": {
      medical:
        "Which of these medical services are necessary for this care? Please select all that apply.",
      "non-medical":
        "Which of these daily living activities are needed for this non-medical care? Please select all that apply:",
      both: "Which of these medical services are necessary for this care? Please select all that apply.",
      default: "",
    },
    "medical-staffing": "How many staff do you need?",
  },
  7: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default: "How many hours of care do you need weekly?",
    },
    "medical-staffing": "When would you like staffing to start?",
  },
  8: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default:
        "When would you like the care services to begin? Please choose the option that fits your needs.",
    },
    "medical-staffing": "How much is your monthly budget for this placement?",
  },
  9: {
    "services-for-families": {
      medical: "",
      "non-medical": "",
      both: "",
      default: "How much is your weekly budget for this care?",
    },
    "medical-staffing": "",
  },
};

export const FORM_INFO = {
  1: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [],
    },
    "medical-staffing": [],
  },
  2: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "radio",
          radioGroup: "authority",
          text: "Myself",
          value: "Myself",
        },
        {
          type: "radio",
          radioGroup: "authority",
          text: "My Parent",
          value: "My Parent",
        },
        {
          type: "radio",
          radioGroup: "authority",
          text: "My Grandparent",
          value: "My Grandparent",
        },
        {
          type: "radio",
          radioGroup: "authority",
          text: "My Spouse",
          value: "My Spouse",
        },
        {
          type: "radio",
          radioGroup: "authority",
          text: "My Client",
          value: "My Patient/My Client",
          description: "For Geriatric Care Managers",
        },
        {
          type: "radio",
          radioGroup: "authority",
          text: "Other (Please specify)",
          value: "other",
        },
      ],
    },
    "medical-staffing": [{ type: "role-form", text: "", value: "" }],
  },
  3: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "radio",
          radioGroup: "clientLivingSituation",
          text: "Own Home",
          value: "Own Home",
        },
        {
          type: "radio",
          radioGroup: "clientLivingSituation",
          text: "Independent Living",
          value: "Independent Living",
        },
        {
          type: "radio",
          radioGroup: "clientLivingSituation",
          text: "Assisted Living",
          value: "Assisted Living",
        },
        {
          type: "radio",
          radioGroup: "clientLivingSituation",
          text: "Memory Care",
          value: "Memory Care",
        },
      ],
    },
    "medical-staffing": [
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Assisted Living",
        value: "Assisted Living",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Continuing Care Retirement Community",
        value: "Continuing Care Retirement Community",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Habilitation/Rehabilitation",
        value: "Habilitation/Rehabilitation",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Home Care",
        value: "Home Care",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Home Health",
        value: "Home Health",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Hospice/Palliative",
        value: "Hospice/Palliative",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Hospital",
        value: "Hospital",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Independent Living/Retirement Community",
        value: "Independent Living/Retirement Community",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Skilled Nursing Facilities",
        value: "Skilled Nursing Facilities",
      },
      {
        type: "radio",
        radioGroup: "medicalSetting",
        text: "Other (Please specify)",
        value: "other",
      },
    ],
  },
  4: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "checkbox",
          text: "Non-Medical Care",
          value: "Non-Medical Care",
          description:
            "Instrumental Activities of Daily Living and Activities of Daily Living",
        },
        {
          type: "checkbox",
          text: "Medical Care",
          value: "Medical Care",
          description:
            "Catheter Care, Physical Therapy, Diabetic Insulin Shots, etc.",
        },
      ],
    },
    "medical-staffing": [
      {
        type: "radio",
        radioGroup: "staffingSolution",
        text: "On-Demand (Immediate)",
        value: "On-Demand (Immediate)",
      },
      {
        type: "radio",
        radioGroup: "staffingSolution",
        text: "Supplemental (Flexible)",
        value: "Supplemental (Flexible)",
      },
      {
        type: "radio",
        radioGroup: "staffingSolution",
        text: "Direct Placement",
        value: "Direct Placement (Long-term)",
      },
    ],
  },
  5: {
    "services-for-families": {
      medical: [
        {
          type: "checkbox",
          text: "Catheter Care",
          value: "Catheter Care",
        },
        {
          type: "checkbox",
          text: "Colostomy Bag Care",
          value: "Colostomy Bag Care",
        },
        {
          type: "checkbox",
          text: "Post-Surgery Wound Care",
          value: "Post-Surgery Wound Care",
        },
        {
          type: "checkbox",
          text: "Tube Feedings and Care",
          value: "Tube Feedings and Care",
        },
        {
          type: "checkbox",
          text: "Ventilator Dependent Care",
          value: "Ventilator Dependent Care",
        },
        {
          type: "checkbox",
          text: "Other (Please specify)",
          value: "other",
        },
      ],
      "non-medical": [
        {
          type: "checkbox",
          text: "Companionship",
          value: "Companionship",
        },
        {
          type: "checkbox",
          text: "Exercise Support",
          value: "Exercise Support",
        },
        {
          type: "checkbox",
          text: "Light Housekeeping",
          value: "Light Housekeeping",
        },
        {
          type: "checkbox",
          text: "Meal Preparation",
          value: "Meal Preparation",
        },
        {
          type: "checkbox",
          text: "Shopping Assistance",
          value: "Shopping Assistance",
        },
        {
          type: "checkbox",
          text: "Transportation",
          value: "Transportation",
        },
        {
          type: "checkbox",
          text: "Select all",
          value: "select-all",
        },
      ],
      both: [
        {
          type: "checkbox",
          text: "Ambulation Support",
          value: "Ambulation Support",
        },
        {
          type: "checkbox",
          text: "Companionship",
          value: "Companionship",
        },
        {
          type: "checkbox",
          text: "Dressing",
          value: "Dressing",
        },
        {
          type: "checkbox",
          text: "Exercise Support",
          value: "Exercise Support",
        },
        {
          type: "checkbox",
          text: "Feeding",
          value: "Feeding",
        },
        {
          type: "checkbox",
          text: "Grooming",
          value: "Grooming",
        },
        {
          type: "checkbox",
          text: "Light Housekeeping",
          value: "Light Housekeeping",
        },
        {
          type: "checkbox",
          text: "Meal Preparation",
          value: "Meal Preparation",
        },
        {
          type: "checkbox",
          text: "Personal Hygiene",
          value: "Personal Hygiene",
        },
        {
          type: "checkbox",
          text: "Shopping Assistance",
          value: "Shopping Assistance",
        },
        {
          type: "checkbox",
          text: "Transferring",
          value: "Transferring",
        },
        {
          type: "checkbox",
          text: "Transportation",
          value: "Transportation",
        },
        {
          type: "checkbox",
          text: "Select all",
          value: "select-all",
        },
      ],
      default: [],
    },
    "medical-staffing": [
      {
        type: "checkbox",
        text: "Certified Nursing Assistant (CNA)",
        value: "Certified Nursing Assistant (CNA)",
      },
      {
        type: "checkbox",
        text: "Medication Technician",
        value: "Medication Technician",
      },
      {
        type: "checkbox",
        text: "Licensed Vocational Nurse (LVN)",
        value: "Licensed Vocational Nurse (LVN)",
      },
      {
        type: "checkbox",
        text: "Registered Nurse (RN)",
        value: "Registered Nurse (RN)",
      },
      {
        type: "checkbox",
        text: "Physical Therapist",
        value: "Physical Therapist",
      },
      {
        type: "checkbox",
        text: "Occupational Therapist",
        value: "Occupational Therapist",
      },
      {
        type: "checkbox",
        text: "Front Office Staff",
        value: "Front Office Staff",
      },
      {
        type: "checkbox",
        text: "Personal Concierge",
        value: "Personal Concierge",
      },
      {
        type: "checkbox",
        text: "Select all",
        value: "select-all",
      },
    ],
  },
  6: {
    "services-for-families": {
      medical: [
        {
          type: "checkbox",
          text: "Bed Sore Treatment",
          value: "Bed Sore Treatment",
        },
        {
          type: "checkbox",
          text: "Diabetic Insulin Shots",
          value: "Diabetic Insulin Shots",
        },
        {
          type: "checkbox",
          text: "Medication Management",
          value: "Medication Management",
        },
        {
          type: "checkbox",
          text: "Physical Therapy",
          value: "Physical Therapy",
        },
        {
          type: "checkbox",
          text: "Vital Signs Monitoring",
          value: "Vital Signs Monitoring",
        },
        {
          type: "checkbox",
          text: "Other (Please specify)",
          value: "other",
        },
      ],
      "non-medical": [
        {
          type: "checkbox",
          text: "Ambulation Support",
          value: "Ambulation Support",
        },
        {
          type: "checkbox",
          text: "Dressing",
          value: "Dressing",
        },
        {
          type: "checkbox",
          text: "Feeding",
          value: "Feeding",
        },
        {
          type: "checkbox",
          text: "Grooming",
          value: "Grooming",
        },
        {
          type: "checkbox",
          text: "Personal Hygiene",
          value: "Personal Hygiene",
        },
        {
          type: "checkbox",
          text: "Transferring",
          value: "Transferring",
        },
        {
          type: "checkbox",
          text: "Select all",
          value: "select-all",
        },
      ],
      both: [
        {
          type: "checkbox",
          text: "Bed Sore Treatment",
          value: "Bed Sore Treatment",
        },
        {
          type: "checkbox",
          text: "Catheter Care",
          value: "Catheter Care",
        },
        {
          type: "checkbox",
          text: "Colostomy Bag Care",
          value: "Colostomy Bag Care",
        },
        {
          type: "checkbox",
          text: "Diabetic Insulin Shots",
          value: "Diabetic Insulin Shots",
        },
        {
          type: "checkbox",
          text: "Medication Management",
          value: "Medication Management",
        },
        {
          type: "checkbox",
          text: "Physical Therapy",
          value: "Physical Therapy",
        },
        {
          type: "checkbox",
          text: "Post-Surgery Wound Care",
          value: "Post-Surgery Wound Care",
        },
        {
          type: "checkbox",
          text: "Tube Feedings and Care",
          value: "Tube Feedings and Care",
        },
        {
          type: "checkbox",
          text: "Ventilator Dependent Care",
          value: "Ventilator Dependent Care",
        },
        {
          type: "checkbox",
          text: "Vital Signs Monitoring",
          value: "Vital Signs Monitoring",
        },
        {
          type: "checkbox",
          text: "Other (Please specify)",
          value: "other",
        },
      ],
      default: [],
    },
    "medical-staffing": [{ type: "staffing-form", text: "", value: "" }],
  },
  7: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "radio",
          radioGroup: "numberOfHours",
          text: "Less than 20 hours",
          value: "Less than 20 Hours Weekly",
        },
        {
          type: "radio",
          radioGroup: "numberOfHours",
          text: "20-29 hours",
          value: "20-29 Hours Weekly",
        },
        {
          type: "radio",
          radioGroup: "numberOfHours",
          text: "30-39 hours",
          value: "30-39 Hours Weekly",
        },
        {
          type: "radio",
          radioGroup: "numberOfHours",
          text: "40-49 hours",
          value: "40-50 Hours Weekly",
        },
        {
          type: "radio",
          radioGroup: "numberOfHours",
          text: "More than 50 hours",
          value: "More than 50 Hours Weekly",
        },
      ],
    },
    "medical-staffing": [
      {
        type: "radio",
        radioGroup: "timeline",
        text: "Immediately",
        value: "Immediately",
      },
      {
        type: "radio",
        radioGroup: "timeline",
        text: "1-2 weeks from now",
        value: "1-2 weeks from now",
      },
      {
        type: "radio",
        radioGroup: "timeline",
        text: "3-4 weeks from now",
        value: "3-4 weeks from now",
      },
      {
        type: "radio",
        radioGroup: "timeline",
        text: "More than a month from now",
        value: "More than a month from now",
      },
    ],
  },
  8: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "radio",
          radioGroup: "timeline",
          text: "Within 72 hours",
          value: "Within 72 hours",
        },
        {
          type: "radio",
          radioGroup: "timeline",
          text: "Within 2 weeks",
          value: "Within 2 weeks",
        },
        {
          type: "radio",
          radioGroup: "timeline",
          text: "More than a month from now",
          value: "More than a month from now",
        },
      ],
    },
    "medical-staffing": [
      {
        type: "radio",
        radioGroup: "budget",
        text: "Less than $20,000",
        value: "Less than $20,000 monthly",
      },
      {
        type: "radio",
        radioGroup: "budget",
        text: "$20,000 - $40,000",
        value: "$20,000 - $40,000 monthly",
      },
      {
        type: "radio",
        radioGroup: "budget",
        text: "$41,000 - $60,000",
        value: "$41,000 - $60,000 monthly",
      },
      {
        type: "radio",
        radioGroup: "budget",
        text: "$61,000 - $80,000",
        value: "$61,000 - $80,000 monthly",
      },
      {
        type: "radio",
        radioGroup: "budget",
        text: "$81,000 - $100,000",
        value: "$81,000 - $100,000 monthly",
      },
      {
        type: "radio",
        radioGroup: "budget",
        text: "More than $100,000",
        value: "More than $100,000 monthly",
      },
    ],
  },
  9: {
    "services-for-families": {
      medical: [],
      "non-medical": [],
      both: [],
      default: [
        {
          type: "radio",
          radioGroup: "budget",
          text: "Less than $500",
          value: "Less than $500 weekly",
        },
        {
          type: "radio",
          radioGroup: "budget",
          text: "$500 - $2,000",
          value: "$500 - $2,000 weekly",
        },
        {
          type: "radio",
          radioGroup: "budget",
          text: "$2,000 - $5,000",
          value: "$2,000 - $5,000 weekly",
        },
        {
          type: "radio",
          radioGroup: "budget",
          text: "More than $5,000",
          value: "More than $5,000 weekly",
        },
      ],
    },
    "medical-staffing": [],
  },
};
